import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Link from '@swf/components/Link/Link';
import Button from '@swf/components/StarsButton/StarsButton';
import StarsLink from '@swf/components/StarsLink/StarsLink';
import WebpWithFallback from '@swf/components/WebpWithFallback/WebpWithFallback';
import { Size } from '@swf/core/enums';
import useScreenSize from '@swf/core/hooks/useScreenSize';
import type { Dispatch, RootState } from '@swf/core/store';
import { select } from '@swf/core/store';

import bannerDesktopPNG from '../assets/banner-desktop.png';
import bannerDesktop from '../assets/banner-desktop.webp';
import bannerMobilePNG from '../assets/banner-mobile-tablet.png';
import bannerMobile from '../assets/banner-mobile-tablet.webp';
import logoPNG from '../assets/logo.png';
import logo from '../assets/logo.webp';

import { TXTCLI_Login, TXTWCL_Join } from './Banner.messages.json';
import styles from './Banner.scss';

const offset = 1350;

export const Banner: React.FC = () => {
  const {
    modal: { enqueue }
  } = useDispatch<Dispatch>();
  const openLoginModal = useCallback(() => enqueue({ path: '/auth/login' }), [enqueue]);
  const openRegistrationModal = useCallback(
    () => enqueue({ path: '/auth/registration' }),
    [enqueue]
  );
  const loading = useSelector((rootState: RootState) => rootState.loading.models.auth);
  const isEmbedded = useSelector(select.site.isEmbedded);
  const {
    greaterThan,
    windowSize: { width }
  } = useScreenSize();
  const isMobileDevice = !greaterThan(Size.Medium);
  const marginLeft = width < offset ? width - offset : 0;

  return (
    <section className={styles.banner}>
      {isMobileDevice ? (
        <WebpWithFallback
          src={bannerMobile}
          srcFallback={bannerMobilePNG}
          containerClassName={styles.mobileBanner}
        />
      ) : (
        <WebpWithFallback
          src={bannerDesktop}
          srcFallback={bannerDesktopPNG}
          containerClassName={styles.desktopBanner}
          containerInlineStyle={{ marginLeft }}
        />
      )}
      {/* //TODO: add href once we get our base route. */}
      <Link className={styles.logo} style={{ marginLeft: !isMobileDevice ? marginLeft : 'auto' }}>
        <WebpWithFallback src={logo} srcFallback={logoPNG} />
      </Link>
      <div className={styles.bannerInner}>
        <div className={styles.right}>
          <h1 className={styles.heading}>
            Play poker with <br /> your friends
          </h1>
          {!isEmbedded && (
            <div className={styles.auth}>
              <Button
                className={styles.button}
                size="extra-large"
                inverse
                loading={loading}
                onClick={openRegistrationModal}
                translation={TXTWCL_Join}
              />
              <Button
                className={styles.button}
                inverse
                loading={loading}
                onClick={openLoginModal}
                translation={TXTCLI_Login}
                size="extra-large"
                variant="casino-glass"
              />
            </div>
          )}
          <div className={styles.terms}>
            Must deposit to play real money. <span>18+</span> <br />
            <StarsLink
              href="https://www.begambleaware.org/"
              target="_blank"
              rel="noopener noreferrer"
            >
              BeGambleAware.org
            </StarsLink>
            . Please play responsibly
          </div>
        </div>
      </div>
    </section>
  );
};
